import React, { useMemo, useState } from 'react';
import { StyleSheet, View } from 'react-native';
const DashedLine = _ref => {
  let {
    axis = 'horizontal',
    dashGap = 2,
    dashLength = 4,
    dashThickness = 1,
    dashColor = '#757575',
    dashStyle,
    style
  } = _ref;
  const [lineLength, setLineLength] = useState(0);
  const isRow = axis === 'horizontal';
  const numOfDashes = Math.ceil(lineLength / (dashGap + dashLength));
  const dashStyles = useMemo(() => ({
    width: isRow ? dashLength : dashThickness,
    height: isRow ? dashThickness : dashLength,
    marginRight: isRow ? dashGap : 0,
    marginBottom: isRow ? 0 : dashGap,
    backgroundColor: dashColor
  }), [dashColor, dashGap, dashLength, dashThickness, isRow]);
  return /*#__PURE__*/React.createElement(View, {
    onLayout: event => {
      const {
        width,
        height
      } = event.nativeEvent.layout;
      setLineLength(isRow ? width : height);
    },
    style: [style, isRow ? styles.row : styles.column]
  }, [...Array(numOfDashes)].map((_, i) => {
    return /*#__PURE__*/React.createElement(View, {
      key: i,
      style: [dashStyles, dashStyle]
    });
  }));
};
const styles = StyleSheet.create({
  row: {
    flexDirection: 'row'
  },
  column: {
    flexDirection: 'column'
  }
});
export default DashedLine;
//# sourceMappingURL=DashedLine.js.map